import React from 'react';
import TextField from 'material-ui/TextField';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import NumberFormat from 'react-number-format';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { Grid } from '../../components';
import {
    eventoService,
    subeventoService,
    areaService,
    projetosNotaFinalService,
    tipoApresentacaoService,
} from '../../services';
import PrincipalMaster from '../master/Principal';

class NotasApresentacao extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ano: '',
            dsEventos: [],
            eventoSelecionado: 0,
            dsSubeventos: [],
            subeventoSelecionado: 0,
            dsAreas: [],
            areaSelecionada: 0,
            dsNotasApresentacao: [],
            tipoApresentacaoSelecionado: 0,
            dsTipoApresentacao: [],
            notaState: 0,
            projetoState: 0,
            tipoState: 0,
        };
    }

    async componentWillMount() {
        const ano = new Date().getFullYear();
        const eventos = await eventoService.getEventosPeloAno(ano);

        this.setState({
            ano,
            dsEventos: eventos,
        });
    }

    async getNotasApresentacaoAvaliador(subevento, area, tipoApresentacao) {
        const notasApresentacao = await projetosNotaFinalService.getNotasApresentacaoAvaliador(
            subevento,
            area,
            tipoApresentacao,
        );
        this.setState({ dsNotasApresentacao: notasApresentacao });
    }

    setNota(event, item) {
        // delete nota se já tem
        // projetosNotaFinalService.delete({ projeto: item, tipo: 2 });
        // insere a nota
        projetosNotaFinalService.save({
            nota: event.target.value,
            projeto: item,
            tipo: 2,
        });

        const {
            subeventoSelecionado,
            areaSelecionada,
            tipoApresentacaoSelecionado,
        } = this.state;
        this.getNotasApresentacaoAvaliador(
            subeventoSelecionado,
            areaSelecionada,
            tipoApresentacaoSelecionado,
        );
    }

    async setTipoApresentacao(tipoApresentacaoCodigo) {
        const { subeventoSelecionado, areaSelecionada } = this.state;
        this.setState(
            {
                tipoApresentacaoSelecionado: tipoApresentacaoCodigo,
            },
            () =>
                this.getNotasApresentacaoAvaliador(
                    subeventoSelecionado,
                    areaSelecionada,
                    tipoApresentacaoCodigo,
                ),
        );
    }

    async buscarEventosPeloAno() {
        let eventos = [];
        if (this.state.ano) {
            eventos = await eventoService.getEventosPeloAno(this.state.ano);
        }
        this.setState({
            dsEventos: eventos,
            eventoSelecionado: 0,
            subeventoSelecionado: 0,
            areaSelecionada: 0,
        });
    }

    async buscarSubeventosPeloEvento(eventoCodigo) {
        this.setState({
            eventoSelecionado: eventoCodigo,
            subeventoSelecionado: 0,
            areaSelecionada: 0,
        });

        const dadosSubevento = await subeventoService.getSubeventosDoEvento(
            eventoCodigo,
        );
        this.setState({ dsSubeventos: dadosSubevento });
    }

    async buscarAreasPeloSubevento(subeventoCodigo) {
        this.setState({
            subeventoSelecionado: subeventoCodigo,
            areaSelecionada: 0,
        });

        const areas = await areaService.getAreasCoordenador(subeventoCodigo);
        this.setState({
            dsAreas: areas,
            subeventoSelecionado: subeventoCodigo,
        });
    }

    async buscarAreas(area) {
        const { subeventoSelecionado } = this.state;
        if (area !== 0) {
            const tipoApresentacao = await tipoApresentacaoService.getTiposApresentacao(
                subeventoSelecionado,
            );
            this.setState({
                dsTipoApresentacao: tipoApresentacao,
            });
        }
        this.setState({
            areaSelecionada: area,
        });
    }

    insertNota() {
        const { notaState, projetoState, tipoState } = this.state;

        // delete nota se já tem
        projetosNotaFinalService.delete({ projetoState, tipoState });
        // insere a nota
        projetosNotaFinalService.save({
            notaState,
            projetoState,
            tipoState,
        });
    }

    render() {
        const {
            dsEventos,
            eventoSelecionado,
            dsSubeventos,
            subeventoSelecionado,
            dsAreas,
            areaSelecionada,
            ano,
            dsNotasApresentacao,
            tipoApresentacaoSelecionado,
            dsTipoApresentacao,
        } = this.state;

        return (
            <PrincipalMaster title="Projetos" {...this.props}>
                <div>
                    <form onSubmit={(e) => this.onSave(e)}>
                        <div className="padding-content">
                            <NumberFormat
                                format="####"
                                customInput={TextField}
                                required
                                value={ano}
                                errorText={ano ? '' : 'Campo obrigatório'}
                                floatingLabelText="Ano"
                                onBlur={(e) =>
                                    this.buscarEventosPeloAno(e.target.value)
                                }
                                onChange={(e) =>
                                    this.setState({ ano: e.target.value })
                                }
                            />
                            <br />

                            <SelectField
                                floatingLabelText="Selecione um evento"
                                value={eventoSelecionado}
                                onChange={(_event, _index, value) =>
                                    this.buscarSubeventosPeloEvento(value)
                                }
                                errorText={
                                    eventoSelecionado > 0
                                        ? ''
                                        : 'Campo obrigatório'
                                }
                                fullWidth
                            >
                                {dsEventos.map((evento) => (
                                    <MenuItem
                                        key={evento.CODIGO}
                                        value={evento.CODIGO}
                                        primaryText={evento.NOME}
                                    />
                                ))}
                            </SelectField>

                            <SelectField
                                floatingLabelText="Selecione um subevento"
                                value={subeventoSelecionado}
                                onChange={(_event, _index, value) =>
                                    this.buscarAreasPeloSubevento(value)
                                }
                                fullWidth
                            >
                                <MenuItem value={0} primaryText="Todos" />
                                {dsSubeventos.map((subevento) => (
                                    <MenuItem
                                        key={subevento.CODIGO}
                                        value={subevento.CODIGO}
                                        primaryText={subevento.NOME}
                                    />
                                ))}
                            </SelectField>

                            <SelectField
                                floatingLabelText="Selecione uma área"
                                value={areaSelecionada}
                                onChange={(_event, _index, value) =>
                                    this.buscarAreas(value)
                                }
                                fullWidth
                            >
                                <MenuItem value={0} primaryText="Todas" />
                                {dsAreas.map((area) => (
                                    <MenuItem
                                        key={area.CODIGO}
                                        value={area.CODIGO}
                                        primaryText={area.NOME}
                                    />
                                ))}
                            </SelectField>

                            <h4>Tipo de apresentação</h4>
                            {areaSelecionada > 0 ? (
                                <RadioButtonGroup
                                    name="tipoSubmissao"
                                    value={tipoApresentacaoSelecionado}
                                    defaultSelected={0}
                                    onChange={(_event, tipo) =>
                                        this.setTipoApresentacao(tipo)
                                    }
                                >
                                    <RadioButton value={0} label="Todos" />
                                    {dsTipoApresentacao.map((x) => (
                                        <RadioButton
                                            key={x.CODIGO}
                                            value={x.CODIGO}
                                            label={x.MODALIDADE}
                                        />
                                    ))}
                                </RadioButtonGroup>
                            ) : (
                                <p>
                                    Selecione a area para ver os tipos de
                                    apresentação.
                                </p>
                            )}
                        </div>
                    </form>
                </div>

                <div>
                    <div className="padding-content">
                        <Grid
                            ref={(ref) => {
                                this.projetosGridRef = ref;
                            }}
                            stripedRows="true"
                            textTableEmpty="Nenhum projeto encontrado."
                            dataSource={dsNotasApresentacao}
                            columns={[
                                {
                                    text: 'CODIGO',
                                    name: 'CODIGO',
                                    allowSort: true,
                                    allowSearch: true,
                                    searchOperator: 'LIKE',
                                },
                                {
                                    text: 'TÍTULO',
                                    name: 'TITULO',
                                    allowSort: true,
                                    allowSearch: true,
                                    searchOperator: 'LIKE',
                                },
                                {
                                    text: 'AUTOR(ES)',
                                    name: 'AUTOR(ES)',
                                    allowSort: true,
                                    allowSearch: true,
                                    searchOperator: 'LIKE',
                                },
                                {
                                    text: 'NOTA RESUMO',
                                    name: 'NOTARESUMO',
                                    allowSort: true,
                                    allowSearch: true,
                                    searchOperator: 'LIKE',
                                },
                                {
                                    text: 'NOTA APRESENTAÇÃO',
                                    name: (item, index) => (
                                        <div>
                                            <NumberFormat
                                                placeholder="0,0"
                                                style={{
                                                    border: 'dotted 0px #ccc',
                                                    width: 60,
                                                }}
                                                customInput={TextField}
                                                decimalSeparator=","
                                                thousandSeparator="."
                                                fixedDecimalScale
                                                value={item.NOTAAPRESENTACAO}
                                                onBlur={(e) =>
                                                    this.setNota(
                                                        e,
                                                        item.CODIGO,
                                                        index,
                                                    )
                                                }
                                                required
                                            />
                                        </div>
                                    ),
                                },
                                {
                                    text: 'NOTA FINAL',
                                    name: 'NOTAFINAL',
                                    allowSort: true,
                                    allowSearch: true,
                                    searchOperator: 'LIKE',
                                },
                            ]}
                        />
                    </div>
                </div>
            </PrincipalMaster>
        );
    }
}

export default NotasApresentacao;
